<bp-hl-area-container name="Baumarten">
	<div class="baumarten-area">
		<div *ngIf="hasLegacyString()" class="alert alert-warning legacy-baumarten">
			<strong>Hinweis:</strong> Vorhandener Freitext-Eintrag wird ersetzt durch die strukturierte Tabelle.
			<div class="legacy-content text-muted">{{ legacyString() }}</div>
			<button type="button" class="btn btn-sm btn-outline-primary" (click)="migrateLegacyToTable()">
				Erste Zeile aus Freitext anlegen
			</button>
			<button type="button" class="btn btn-sm btn-outline-danger ms-2" (click)="clearLegacyString()">
				Freitext löschen
			</button>
		</div>

		<table class="table table-sm table-striped">
			<thead>
				<tr>
					<th>Art</th>
					<th>Alter</th>
					<th>Höhe von</th>
					<th>Höhe bis</th>
					<th>Durchmesser von</th>
					<th>Durchmesser bis</th>
					<th>Bonität (-5..+5)</th>
					<th>Qualität</th>
					<th>Aktion</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let ba of baumartenList(); let i = index; trackBy: trackByIndex">
					<td><wd-typeahead name="BaumartArt[{{i}}]" [(model)]="ba.art" [hideComments]="true"></wd-typeahead></td>
					<td><wd-number-input name="BaumartAlter[{{i}}]" [(model)]="ba.alter" [hideComments]="true"></wd-number-input></td>
					<td><wd-number-input name="BaumartHoeheVon[{{i}}]" [(model)]="ba.hoehe.first" [hideComments]="true"></wd-number-input></td>
					<td><wd-number-input name="BaumartHoeheBis[{{i}}]" [(model)]="ba.hoehe.second" [hideComments]="true"></wd-number-input></td>
					<td><wd-number-input name="BaumartDurchmesserVon[{{i}}]" [(model)]="ba.durchmesser.first" [hideComments]="true"></wd-number-input></td>
					<td><wd-number-input name="BaumartDurchmesserBis[{{i}}]" [(model)]="ba.durchmesser.second" [hideComments]="true"></wd-number-input></td>
					<td><wd-number-input name="BaumartBonitaet[{{i}}]" [(model)]="ba.Bonitaet" [hideComments]="true" [min]="-5" [max]="5"></wd-number-input></td>
					<td><wd-list-input name="BaumartQualitaet[{{i}}]" [(model)]="ba.qualitaet" [hideComments]="true"></wd-list-input></td>
					<td><button type="button" class="btn btn-danger btn-sm" title="Probestamm löschen" (click)="onRemoveBaumart(i)"><i class="bi bi-trash"></i></button></td>
				</tr>
				<tr *ngIf="baumartenList().length === 0 && !hasLegacyString()">
					<td colspan="9" class="text-muted text-center">Noch keine Probestämme erfasst.</td>
				</tr>
				<tr>
					<td colspan="9">
						<button type="button" class="btn btn-info baumarten-add" title="Probestamm hinzufügen" (click)="onAddBaumart()">
							<i class="bi bi-plus"></i> Probestamm hinzufügen
						</button>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</bp-hl-area-container>
